<h1>Prescription Auditing<button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<hr>
<div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-12">
    <form [formGroup]="OpdForm" (submit)="updateOpdForPrescription()">
        <div class="row">
            <div class="col-sm-4 mt-4">
                <label class="form-label">Surgery Suggest</label>
                    <mat-select placeholder="Surgery Suggest" formControlName="pres_audit_surgery_suggest">
                    <mat-option value="">Select Surgery Suggest</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-4 mt-4">
                <label class="form-label">Prescription Status</label>
                    <mat-select placeholder="Prescription Status" formControlName="pres_audit_prescription_status">
                    <mat-option value="">Select Prescription Status</mat-option>
                    <mat-option value="Upload">Upload</mat-option>
                    <mat-option value="Wrong upload">Wrong upload</mat-option>
                    <mat-option value="Not upload">Not upload</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-4 mt-4">
                <label class="form-label">Name</label>
                    <mat-select placeholder="Name" formControlName="pres_audit_name">
                    <mat-option value="">Select Name</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-4 mt-4">
                <label class="form-label">Age</label>
                    <mat-select placeholder="Age" formControlName="pres_audit_age">
                    <mat-option value="">Select Age</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-4 mt-4">
                <label class="form-label">Gender</label>
                    <mat-select placeholder="Gender" formControlName="pres_audit_gender">
                    <mat-option value="">Select Gender</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-4 mt-4">
                <label class="form-label">Date</label>
                    <mat-select placeholder="Date" formControlName="pres_audit_date">
                    <mat-option value="">Select Date</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-4 mt-4">
                <label class="form-label">Signature / Stamp</label>
                    <mat-select placeholder="Signature / Stamp" formControlName="pres_audit_signature">
                    <mat-option value="">Select Signature / Stamp</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-4 mt-4">
                <label class="form-label">Medication Advised</label>
                    <mat-select placeholder="Medication Advised" formControlName="pres_audit_medication_advised">
                    <mat-option value="">Select Medication Advised</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>

            <div class="col-sm-4 mt-4">
                <label class="form-label">Medication Advised Days</label>
                    <mat-select placeholder="Medication Advised Days" formControlName="pres_audit_medication_advised_days">
                    <mat-option value="">Select Medication Advised Days</mat-option>
                    <mat-option value="Upto 3">Upto 3</mat-option>
                    <mat-option value="Upto 5">Upto 5</mat-option>
                    <mat-option value="Upto 10">Upto 10</mat-option>
                    <mat-option value="Upto 30 days">Upto 30 days</mat-option>
                </mat-select>
            </div>

            <div class="col-sm-4 mt-4">
                <label class="form-label">History Mentioned</label>
                    <mat-select placeholder="History Mentioned" formControlName="pres_audit_history_mentioned">
                    <mat-option value="">Select History Mentioned</mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                </mat-select>
            </div>

            <div class="col-sm-4 mt-4">
                <label class="form-label">Investigations</label>
                    <mat-select placeholder="Investigations" formControlName="pres_audit_history_investigations">
                    <mat-option value="">Select Investigations</mat-option>
                    <mat-option value="Advised">Advised</mat-option>
                    <mat-option value="Not advised">Not advised</mat-option>
                </mat-select>
            </div>

            <div class="col-sm-4 mt-4">
                <label class="form-label">Surgery Date</label>
                    <mat-select placeholder="Surgery Date" formControlName="pres_audit_surgery_date">
                    <mat-option value="">Select Surgery Date</mat-option>
                    <mat-option value="Mentioned">Mentioned</mat-option>
                    <mat-option value="Not mentioned">Not mentioned</mat-option>
                </mat-select>
            </div>
           
        </div>
        <br>
        <div class="card-footer mt-5">
            <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
        </div>
    </form>
    </div>
</div>
